import type { SVGProps } from 'react';

const SvgAutomations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9 15c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M9 9c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2zM7 5h2v2H7zm4.5 6H8c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1h4.5c.55 0 1-.45 1-1s-.45-1-1-1m7 5c-.55 0-1 .45-1 1H14c-.55 0-1 .45-1 1s.45 1 1 1h4.5c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1m-3.07-1.21c.36.36.84.55 1.32.55s.96-.18 1.32-.55l1.38-1.38c.73-.73.73-1.92 0-2.64l-1.38-1.38c-.73-.73-1.92-.73-2.64 0l-1.38 1.38c-.73.73-.73 1.92 0 2.64zm1.32-3.9 1.2 1.2-1.2 1.2-1.2-1.2z"
    />
  </svg>
);
export default SvgAutomations;
